import { CreateNewVoucherForm } from './create-new-voucher-form'

export const CreateNewVoucher = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateNewVoucherForm onCloseModal={onCloseModal} />
}
